export function Logo({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <mask id="garimpa-logo">
          <circle cx="24" cy="24" r="22" fill="white" />
          <circle cx="24" cy="24" r="17" fill="none" stroke="black" strokeWidth="1.2" />
          <circle cx="24" cy="24" r="12" fill="none" stroke="black" strokeWidth="1.2" />
          <polygon points="24,19 29,24 24,29 19,24" fill="black" />
        </mask>
      </defs>
      <circle cx="24" cy="24" r="22" fill="currentColor" mask="url(#garimpa-logo)" />
    </svg>
  );
}
